module.exports = __webpack_public_path__ + "img/csc.6485da05.jpg";